define('views/content/metrik_user_registration',['require','views/base/item_page_view','typeahead','bloodhound','models/metrik_user','text!templates/content/metrik_user_registration.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');

    var MetrikUserrModel = require('models/metrik_user');

    var temp = require("text!templates/content/metrik_user_registration.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        afterInitialize: function () {
            var _this = this;

        },

        initialize: function (options) {
            this.code = options.code;
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',
                backButton: '#back-button',

                emailField: '#email',
                firstNameField: '#first-name',
                lastNameField: '#last-name',
                passwordField: '#password',
                passwordConfirmField: '#password-confirm',
                gdprField: '#allow_gdpr',

                gdprLink: '#gdpr-link',
                kvkkLink: '#kvkk-link',
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form checkbox': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',

            'click @ui.backButton': 'backButtonClicked',


            'click @ui.gdprLink': 'gdprLinklClicked',
            'click @ui.kvkkLink': 'kvkkLinkClicked'
        },

        afterRender: function () {
            var _this = this;
     
            $.ajax({
                url: App.Config.apiBase + "metrik-users/verify_code/",
                method: "post",
                data:{
                    code: _this.code
                },
                success: function(data){
                    _this.model.set('email', data.email);
                    _this.ui.emailField.text(data.email);
                },
                error: function(xhr){
                    // Show error messages
                     if (xhr.responseJSON.errors) {
                      for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                          App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                      }
                      setTimeout(function () {
                        App.context.redirect('/');
                      }, 2*1000);
                     }
                }
            });
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'first_name': "required",
                    'last_name': "required",
                    'password': "required",
                    'password_confirm': {
                        equalTo: '[name="password"]'
                    },
                },
                messages: {
                    'first_name': App.polyglot.t('manager_first_name_required'),
                    'last_name': App.polyglot.t('manager_last_name_required'),
                    'password': App.polyglot.t('password_required'),
                    'password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    },
                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        beforeSubmit: function() {

            
            return true;
        },

       afterSuccess: function(response) {
           App.context.redirect('/');
           App.utils.showMessage('success', App.polyglot.t('registration_success'));
       },

        backButtonClicked: function () {
            window.history.back('/');
        },

        gdprLinklClicked: function (event) {
            window.open('https://gdpr.eu/tag/gdpr/', '_blank');
        },

        kvkkLinkClicked: function () {
            window.open('https://www.mevzuat.gov.tr/mevzuat?MevzuatNo=6698&MevzuatTur=1&MevzuatTertip=5', '_blank');
        }        
    });
});
